<template>
  <div>
    <div>
      <field-group
        type-input="v-select"
        inline
        label="Loại nhãn"
        v-model="p_value.icon_type"
        @input="onChangeTypeValue()"
        :items="itemsIconTypes"
      ></field-group>
    </div>
    <div v-if="p_value.icon_type">
      <div v-if="p_value.icon_type == 'shape'" key="shape">
        <!-- <field-group
          type-input="v-select"
          inline
          label="Loại hình"
          v-model="p_value.shape_type"
          @input="onChangeValue()"
          :items="itemsShapeTypes"
        ></field-group> -->
        <template v-for="input of inputsShape">
          <ruleGroupInput
            v-if="input.children && input.children.length > 0"
            :key="input.value"
            :field="input"
            @input="onChangeValue()"
            v-model="p_value"
            :autocomplete="input.autocomplete"
          />
          <ruleInput
            v-else
            :typeInput="input.type"
            :label="input.label"
            :key="input.value + '-else'"
            @input="onChangeValue()"
            v-model="p_value[input.value]"
            :autocomplete="input.autocomplete"
          ></ruleInput>
        </template>
      </div>
      <div v-else-if="p_value.icon_type == 'image'">
        <field-group
          inline
          label="Ảnh"
          v-if="p_value.icon_type == 'image'"
          key="image"
        >
          <template #input>
            <v-select
              v-model="p_value.image_id"
              @input="onChangeValue()"
              :items="itemsImage"
              item-text="name"
              item-value="id"
              readonly
            >
              <template #append-outer>
                <v-icon @click="onShowImageDialog()">mdi-plus</v-icon>
              </template>
            </v-select>
            <div v-if="itemsImage && itemsImage.length > 0">
              <v-img
                :src="itemsImage[0].patch"
                contain
                :aspect-ratio="4 / 3"
                style="border: 1px solid #7fb3d5"
              />
            </div>
          </template>
        </field-group>
      </div>
    </div>
    <IconDialog ref="icondialog" @submit="onSetImage" />
  </div>
</template>

<script>
import ruleInput from './edit-rule-input.vue'
import ruleGroupInput from './edit-rule-group-input.vue'
import IconDialog from './icon-dialog.vue'
import { API_SYMBOL } from '@/src/service/api'
export default {
  components: { ruleInput, ruleGroupInput, IconDialog },
  props: {
    value: {
      default: () => ({}),
    },
  },
  data: () => ({
    itemsImage: [],
    itemsIconTypes: [
      { text: 'Hình', value: 'shape' },
      { text: 'Ảnh', value: 'image' },
    ],
    itemsShapeTypes: [
      { text: 'Hình tròn', value: 'circle' },
      { text: 'Hình vuông', value: 'square' },
      { text: 'Hình tam giác', value: 'triangle' },
      { text: 'Hình ngôi sao', value: 'star' },
      { text: 'Hình thập tự', value: 'cross' },
    ],
    p_value: {
      icon_type: 'shape',
      shape_type: 'square',
      fill: '#000000',
      stroke: '#000000',
      'fill-opacity': 1,
    },
    inputsShape: [
      {
        label: 'Màu',
        value: 'fill',
        type: 'color',
        acceptsExpression: true,
        defaultValue: '#000000',
      },
      {
        label: 'Sử dụng viển?',
        value: 'use_stroke',
        children: [
          {
            label: 'Màu viền',
            value: 'stroke',
            type: 'color',
            acceptsExpression: true,
            defaultValue: '#000000',
          },
          {
            label: 'Độ dày',
            value: 'stroke-width',
            type: 'length',
            acceptsExpression: true,
            defaultValue: 1,
          },
          {
            label: 'Độ trong suốt viền',
            value: 'stroke-opacity',
            type: 'percentage',
            defaultValue: 1,
          },
        ],
      },
    ],
  }),
  watch: {
    value: {
      handler(value) {
        this.p_value = Object.assign({}, value)
      },
      immediate: true,
    },
  },
  computed: {
    form: {
      get() {
        return this.p_value
      },
      set(value) {
        this.p_value = value
        this.$emit('input', value)
      },
    },
  },
  created() {
    if (this.p_value.image_id) {
      API_SYMBOL.getDetail(this.p_value.image_id).then((res) => {
        this.itemsImage = [res.data]
      })
    }
  },
  methods: {
    onChangeValue() {
      this.$emit('input', this.p_value)
    },
    onChangeTypeValue() {
      this.itemsImage = []
      if (this.p_value.icon_type == 'shape') {
        this.p_value = {
          icon_type: 'shape',
          shape_type: this.p_value.shape_type || 'square',
          fill: this.p_value.fill || '#000000',
          stroke: this.p_value.stroke || '#000000',
          use_stroke: this.p_value.use_stroke || false,
          'fill-opacity': this.p_value['fill-opacity'] || 1,
        }
      } else {
        this.p_value = {
          icon_type: 'image',
          image_id: this.p_value.image_id,
        }
      }
      this.$set(this.p_value, 'icon_type', this.p_value.icon_type)
      this.onChangeValue()
    },
    onShowImageDialog() {
      this.$refs.icondialog.open()
    },
    onSetImage(image) {
      this.p_value.image_id = image.id
      this.itemsImage = [image]
      this.onChangeValue()
    },
  },
}
</script>

<style scoped></style>
